// oxlint-disable-next-line no-restricted-imports -- this is the theme!
import {
  amber,
  blue,
  blueGrey,
  brown,
  cyan,
  deepOrange,
  deepPurple,
  grey,
  lightBlue,
  lightGreen,
  lime,
  orange,
  pink,
  red,
  teal,
  yellow,
} from '@mui/material/colors'

declare module '@mui/material/styles' {
  interface Palette {
    green: {
      50: string
      100: string
      200: string
      300: string
      500: string
      700: string
      900: string
    }
    red: {
      50: string
      100: string
      200: string
      300: string
      500: string
      700: string
      900: string
    }
    purple: {
      50: string
      100: string
      300: string
      500: string
      700: string
    }
    indigo: {
      50: string
      100: string
      200: string
      300: string
      400: string
      500: string
      600: string
      700: string
      800: string
      900: string
    }
    yellow: typeof yellow
    deepOrange: typeof deepOrange
    orange: typeof orange
    lime: typeof lime
    amber: typeof amber
    blue: typeof blue
    lightBlue: typeof lightBlue
    cyan: typeof cyan
    teal: typeof teal
    lightGreen: typeof lightGreen
    brown: typeof brown
    blueGrey: typeof blueGrey
    pink: typeof pink
    deepPurple: typeof deepPurple
    riskScore: {
      dark: {
        color: {
          0: string
          1: string
          2: string
          3: string
          4: string
          5: string
        }
        background: {
          0: string
          1: string
          2: string
          3: string
          4: string
          5: string
        }
        border: {
          0: string
          1: string
          2: string
          3: string
          4: string
          5: string
        }
      }
      light: {
        color: {
          0: string
          1: string
          2: string
          3: string
          4: string
          5: string
        }
        border: {
          0: string
          1: string
          2: string
          3: string
          4: string
          5: string
        }
        background: {
          0: string
          1: string
          2: string
          3: string
          4: string
          5: string
        }
      }
    }
    danger: {
      light: string
      main: string
      dark: string
      contrastText: string
      100: string
    }
  }

  interface PaletteOptions {
    green: {
      50: string
      100: string
      200: string
      300: string
      500: string
      700: string
      900: string
    }
    purple: {
      50: string
      100: string
      300: string
      500: string
      700: string
    }
    yellow: typeof yellow
    deepOrange: typeof deepOrange
    orange: typeof orange
    lime: typeof lime
    amber: typeof amber
    blue: typeof blue
    lightBlue: typeof lightBlue
    cyan: typeof cyan
    teal: typeof teal
    lightGreen: typeof lightGreen
    brown: typeof brown
    blueGrey: typeof blueGrey
    pink: typeof pink
    deepPurple: typeof deepPurple
  }
}

/**
 * @deprecated The v1 palette, merged into the theme2 palette so call sites that
 * still read its paths keep resolving. Add nothing here — use `tokens/palette.ts`.
 */
export const legacyPalette = {
  success: {
    main: '#388E3C',
    light: '#E8F5E9',
    contrastText: '#FFF',
    100: '#C8E6C9',
    200: '#E1FEF2',
    500: '#10B981',
  },
  warning: {
    main: '#FF8F00',
    contrastText: '#FFF',
    100: '#FFE082',
    light: '#FFF8E1',
    zero: '#FFF3E0',
    300: '#FFB74D',
    500: '#FF9800',
    900: '#F57F17',
  },
  danger: {
    light: '#FFF3E0',
    main: '#E65100',
    dark: '#E31B0C',
    contrastText: '#FFFFFF',
    100: '#FFA726',
  },
  error: {
    light: '#FEEBEE',
    main: '#E55050',
    dark: '#E31B0C',
    contrastText: '#FFFFFF',
    100: '#FECDD2',
    200: '#F88078',
    500: '#F44336',
  },
  info: {
    main: '#1976D2',
    light: '#E3F2FD',
    contrastText: '#FFF',
    100: '#BBDEFB',
  },
  secondary: {
    main: '#7B61FF',
    dark: '#3F35CB',
    light: '#F2EDFF',
    contrastText: '#FFF',
    100: '#E1D3FF',
  },
  green: {
    50: '#E1FEF2',
    100: '#B5F7DB',
    200: '#81C784',
    300: '#5DECB1',
    500: '#10B981',
    700: '#008854',
    800: '#2E7D32',
    900: '#005F3A',
  },
  purple: {
    50: '#F2EDFF',
    100: '#E1D3FF',
    300: '#B290FF',
    500: '#7B61FF',
    700: '#3F35CB',
  },
  indigo: {
    50: '#E8EAF6',
    100: '#C5CAE9',
    200: '#9FA8DA',
    300: '#7986CB',
    400: '#5C6BC0',
    500: '#3F51B5',
    600: '#3949AB',
    700: '#303F9F',
    800: '#283593',
    900: '#1A237E',
  },
  yellow,
  deepOrange,
  red,
  orange,
  lime,
  amber,
  blue,
  lightBlue,
  cyan,
  teal,
  lightGreen,
  brown,
  blueGrey,
  pink,
  deepPurple,
  riskScore: {
    dark: {
      color: {
        0: '#111116',
        1: '#111116',
        2: '#111116',
        3: '#111116',
        4: '#111116',
        5: '#111116',
      },
      background: {
        0: '#E7E7ED',
        1: 'rgba(205, 220, 57, 0.7)',
        2: 'rgba(251, 206, 45, 0.7)',
        3: 'rgba(255, 167, 38, 0.7)',
        4: 'rgba(245, 124, 0, 0.7)',
        5: 'rgba(239, 83, 80, 0.7)',
      },
      border: {
        0: '#E7E7ED',
        1: 'rgba(205, 220, 57, 0.7)',
        2: 'rgba(251, 206, 45, 0.7)',
        3: 'rgba(255, 167, 38, 0.7)',
        4: 'rgba(245, 124, 0, 0.7)',
        5: 'rgba(239, 83, 80, 0.7)',
      },
    },
    light: {
      color: {
        0: grey[600],
        1: lime[800],
        2: yellow[900],
        3: amber[800],
        4: orange[700],
        5: red[600],
      },
      border: {
        0: grey[400],
        1: lime[600],
        2: yellow[600],
        3: amber[500],
        4: orange[400],
        5: red[400],
      },
      background: {
        0: grey[50],
        1: lime[50],
        2: yellow[50],
        3: amber[50],
        4: orange[50],
        5: red[50],
      },
    },
  },
}
